import type { IndexingStatus } from '@vrzl/database';

/** UI-only filter voor de documentenlijst: alles, of één verwerkingsstatus. */
export type DocumentFilter = 'all' | IndexingStatus;

/** Volgorde van de filterknoppen: alles, daarna de statussen in verwerkingsvolgorde. */
export const DOCUMENT_FILTERS: readonly DocumentFilter[] = [
  'all',
  'NOT_INDEXED',
  'INDEXING',
  'INDEXED',
  'FAILED_WITH_ERRORS',
];

/** Query-param waarin het statusfilter in de URL staat (bijv. `?status=NOT_INDEXED`). */
export const DOCUMENT_FILTER_PARAM = 'status';

/** Leest een URL-waarde als filter; onbekend of leeg wordt "alles". */
export function parseDocumentFilter(value: string | null): DocumentFilter {
  return DOCUMENT_FILTERS.find((filter) => filter === value) ?? 'all';
}

type WithStatus = { indexingStatus: IndexingStatus };

export function filterByStatus<T extends WithStatus>(
  items: readonly T[],
  filter: DocumentFilter,
): T[] {
  if (filter === 'all') return [...items];
  return items.filter((item) => item.indexingStatus === filter);
}

/** Aantal documenten per filterknop, altijd over de volledige lijst. */
export function countByStatus(items: readonly WithStatus[]): Record<DocumentFilter, number> {
  const counts: Record<DocumentFilter, number> = {
    all: items.length,
    NOT_INDEXED: 0,
    INDEXING: 0,
    INDEXED: 0,
    FAILED_WITH_ERRORS: 0,
  };
  for (const item of items) counts[item.indexingStatus] += 1;
  return counts;
}
